// Custom.js
$(document).on("click",".menu-humburger",function(event){
    $(".menu-humburger,.custom-megamenu-wrapper").toggleClass("active");
    event.stopPropagation();
});

// Hide megamenu when clicking outside of it
$(document).on('click', function(event) {
    if (!$(event.target).closest('.menu-humburger').length) {
        $('.menu-humburger, .custom-megamenu-wrapper').removeClass(`active`); // Hide the megamenu
    }
});

$('.custom-megamenu-wrapper .tab-header').hover(function() {
    $(".custom-megamenu-wrapper .tab-header, .custom-megamenu-wrapper .tab-content").removeClass("active");
    $(this).addClass('active');
    var targetTabContent = $(this).attr("data-tab-handle");
    $(`.custom-megamenu-wrapper .tab-content[data-tab-handle=${targetTabContent}]`).addClass('active');
});